import React, { useEffect, useCallback, useState } from "react"
import { Listbox_s } from "styles/input-styles"

type ListboxOption = {
  label: string,
  value: string|number
}

const ListboxInput = (props: {className?:string, field: string, value: any|any[], options:ListboxOption[], multiple: boolean, persist: Function, disabled?: boolean}) => {
  const [, updateState] = useState<{}>();
  const forceUpdate = useCallback(() => updateState({}), []);

  function template(option) {
    const checked = props.multiple ? props.value.includes(option.value) : props.value === option.value
    return (
      <div>
        <input type="checkbox" className={`${props.className} listbox-checkbox` || ''} key={Math.random()} checked={checked} />
        <span>{option.label}</span>
      </div>
    );
  }

  useEffect(() => {
    forceUpdate();
  }, [props.value])

  return (
    <Listbox_s 
      disabled={props.disabled || false}
      itemTemplate={template}
      value={props.value} 
      options={props.options} 
      onChange={(e)=>props.persist(props.field, e.value)}
      multiple={props.multiple}
    />
  )
}

export default ListboxInput